export default function InitRequestModal() {
  const btnSelector = '[data-open-request]';

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest(btnSelector);
    if (!btn) return;

    const tpl = document.getElementById('tpl-request-form');
    if (!tpl) return;

    // 템플릿 복제(이벤트 바인딩 편하게 DOM으로)
    const wrap = document.createElement('div');
    wrap.innerHTML = tpl.innerHTML.trim();
    const form = wrap.querySelector('[data-request-form]');
    const errEl = wrap.querySelector('[data-request-error]');

    // 회원이면 이름 자동 채우기
    const nameInput = wrap.querySelector('input[name="user-name"]');
    if (
      nameInput &&
      window.frontendAjaxObject?.is_logged_in &&
      window.frontendAjaxObject?.userName
    ) {
      nameInput.value = window.frontendAjaxObject.userName;
      // 원하면 readonly 처리
      // nameInput.readOnly = true;
    }

    // 취소 버튼
    wrap.querySelector('[data-close]')?.addEventListener('click', () => {
      window.ZEEIN?.modal?.close();
    });

    // submit 처리
    form?.addEventListener('submit', async (ev) => {
      ev.preventDefault();

      // 에러 초기화
      if (errEl) {
        errEl.textContent = '';
        errEl.classList.add('hidden');
      }

      const fd = new FormData(form);
      const payload = {
        name: (fd.get('user-name') || '').toString().trim(),
        phone: (fd.get('user-phone') || '').toString().trim(),
        subject: (fd.get('user-subject') || '').toString().trim(),
        content: (fd.get('user-content') || '').toString().trim(),
        privacyPolicy: fd.get('privacy-policy') === 'on' ? 1 : 0,
        nonce: window.frontendAjaxObject?.nonce || '',
      };

      // 기본 검증
      if (
        !payload.name ||
        !payload.phone ||
        !payload.subject ||
        !payload.content
      ) {
        if (errEl) {
          errEl.textContent = '필수 값을 모두 입력해주세요.';
          errEl.classList.remove('hidden');
        }
        return;
      }
      if (!payload.privacyPolicy) {
        if (errEl) {
          errEl.textContent = '개인정보 수집 및 이용에 동의해주세요.';
          errEl.classList.remove('hidden');
        }
        return;
      }

      // 연락처 형식 검증(간단히 숫자, -, 공백만 허용)
      const phoneInput = wrap.querySelector('input[name="user-phone"]');
      if (phoneInput) {
        const sanitizePhone = (v = '') => v.replace(/[^\d-]/g, '');

        phoneInput.addEventListener('input', () => {
          const next = sanitizePhone(phoneInput.value);
          if (phoneInput.value !== next) phoneInput.value = next;
        });

        phoneInput.addEventListener('paste', (e) => {
          e.preventDefault();
          const text =
            (e.clipboardData || window.clipboardData)?.getData('text') || '';
          const cleaned = sanitizePhone(text);
          // 커서 위치 고려 없이 덮어쓰기(간단/안정)
          phoneInput.value = cleaned;
          phoneInput.dispatchEvent(new Event('input', { bubbles: true }));
        });

        // (선택) 맨 앞/뒤에 -가 오거나 -- 연속 방지하고 싶으면 blur에서 정리
        phoneInput.addEventListener('blur', () => {
          phoneInput.value = phoneInput.value
            .replace(/-+/g, '-') // 연속 - 하나로
            .replace(/^-+/, '') // 앞쪽 - 제거
            .replace(/-+$/, ''); // 뒤쪽 - 제거
        });
      }

      const digits = payload.phone.replaceAll('-', '');
      if (digits.length < 9) {
        if (errEl) {
          errEl.textContent =
            '연락처를 올바르게 입력해주세요. 예) 010-1234-5678';
          errEl.classList.remove('hidden');
        }
        return;
      }

      const submitBtn = wrap.querySelector('[data-submit]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = '접수 중...';
      }

      try {
        const restUrl = window.frontendAjaxObject?.restUrlRequest;
        const restNonce = window.frontendAjaxObject?.restNonce;
        const res = await fetch(restUrl, {
          method: 'POST',
          headers: {
            'X-WP-Nonce': restNonce,
            'Content-Type': 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify(payload),
        });

        const data = await res.json().catch(() => ({}));

        if (!res.ok || !data?.ok) {
          const msg =
            data?.message || '접수에 실패했습니다. 잠시 후 다시 시도해주세요.';
          if (errEl) {
            errEl.textContent = msg;
            errEl.classList.remove('hidden');
          }
          return;
        }

        // ✅ 접수 완료 모달
        window.ZEEIN?.modal?.open({
          mode: 'card',
          size: 'md',
          title: '문의가 접수되었습니다',
          subtitle: `접수번호: ${data.id}`,
          description: '담당자가 확인 후 빠르게 답변드리겠습니다.',
          thumb: '', // 필요하면 아이콘 이미지 경로
          actions: [
            {
              label: '확인',
              variant: 'primary',
              onClick: () => window.ZEEIN.modal.close(),
            },
          ],
        });
      } catch (err) {
        if (errEl) {
          errEl.textContent = '네트워크 오류가 발생했습니다.';
          errEl.classList.remove('hidden');
        }
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = '문의 접수';
        }
      }
    });

    // ✅ 폼 모달 오픈
    window.ZEEIN?.modal?.open({
      mode: 'custom',
      size: 'md',
      title: '1:1 문의 접수',
      body: wrap, // DOM 주입(깨짐 방지)
    });
  });
}
